import React from 'react';
import { Box, Typography } from '@mui/material';

import { KLASSEN } from '../klassen';

/**
 * Kleine feste Legende „schlecht / ok / gut" in einer Kartenecke (§7).
 * Farben stammen aus der einen KLASSEN-Definition.
 */
const DonutLegend: React.FC = () => (
  <Box className="donut-legend">
    <Typography
      className="donut-legend-title"
      sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}
    >
      <Box component="img" src="/maize.png" alt="" sx={{ width: '1em', height: '1em', flex: '0 0 auto' }} />
      Zustand
    </Typography>
    <Box className="donut-legend-items">
      {KLASSEN.map((k) => (
        <Box key={k.key} className="donut-legend-item">
          <Box className="donut-legend-swatch" sx={{ backgroundColor: k.farbe }} />
          <span>{k.label}</span>
        </Box>
      ))}
    </Box>
  </Box>
);

export default DonutLegend;
